<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'GroupList',
              }"
            >
              群組管理
            </b-breadcrumb-item>

            <b-breadcrumb-item active>查看群組用戶名單</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>
    <b-card>
      <b-overlay :show="showLoading" rounded="sm">
        <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
          <div class="col-12 col-xl-4 mb-1 mb-xl-0 font-weight-bold">
            <h4 class="font-weight-bold">查看群組用戶名單</h4>
            <p>群組名稱: {{ this.group.name }}</p>
          </div>
          <div
            class="
              col-12 col-xl-8
              d-flex
              flex-column flex-xl-row
              align-items-start align-items-xl-center
            "
          >
            <b-input-group class="ml-0 ml-xl-4">
              <b-form-input
                placeholder="搜尋Line暱稱,Line User Token"
                v-model="keyword"
                v-on:keyup.enter="fetchGroupCustomers(currentPage)"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="fetchGroupCustomers(currentPage)"
                  ><i class="fa fa-search"></i
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <b-table
          striped
          hover
          responsive
          :items="customers"
          :fields="fields"
          :sort-by.sync="sortBy"
        >
          <template #cell(customer_group.join_at)="data">
            {{ formatDate(data.item.customer_group.join_at) }}
          </template>
        </b-table>
        <div class="d-flex justify-content-center" style="margin-top: 80px">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            @change="fetchGroupCustomers"
          ></b-pagination>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import groupApi from "../../../apis/group";
import moment from "moment";

export default {
  name: "GroupCustomerList",
  data() {
    return {
      sortBy: "join_datetime",
      showLoading: true,
      currentPage: 1,
      totalRows: 1,
      perPage: 10,
      fields: [
        {
          key: "name",
          label: "Line 暱稱",
        },
        {
          key: "outer_code",
          label: "Line UID",
        },
        {
          key: "customer_group.join_at",
          label: "加入群組時間",
          sortable: true,
        },
      ],
      customers: [],
      keyword: null,
      group: { name: null },
    };
  },
  mounted() {
    this.fetchGroup();
    this.fetchGroupCustomers();
  },
  methods: {
    async fetchGroupCustomers(page) {
      this.showLoading = true;

      const params = {
        page: page || this.currentPage,
      };
      if (this.keyword) params.keyword = this.keyword;

      try {
        const { data } = await groupApi.getGroupCustomers(
          this.$route.params.group_id,
          params
        );
        this.customers = data.data;
        this.totalRows = data.meta.total;
        this.perPage = data.meta.per_page;
      } catch (error) {
        console.log(error);
        alert("取得群組用戶名單資料錯誤");
      }

      this.showLoading = false;
    },
    async fetchGroup() {
      this.showLoading = true;

      try {
        const { data } = await groupApi.getGroup(this.$route.params.group_id);
        this.group = data;
      } catch (error) {
        console.log(error);
        alert("取得群組資料錯誤");
      }

      this.showLoading = false;
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm");
      }
    },
  },
};
</script>

<style scoped></style>
